import axios, { apiBaseURL } from './axios'

const testimonialsBaseURL = `${apiBaseURL}/testimonials`

export default class TestimonialsApi {
  static getTestimonials(): Promise<ITestimonials> {
    return axios.get(`${testimonialsBaseURL}`)
  }
}
